import { AxiosPromise, AxiosRequestConfig } from 'axios';
import { instance, instanceApi } from 'libs';
import * as Types from 'types';

export const getHistoryReceiving = (
  params: Types.GetHistoryReceivingRequest
): AxiosPromise<Types.GetHistoryReceivingResponse> => {
  const request: AxiosRequestConfig = {
    // url: '/shop/sites',
    url: '/information',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getHistorySending = (
  params: Types.GetHistorySendingRequest
): AxiosPromise<Types.GetHistorySendingResponse> => {
  const request: AxiosRequestConfig = {
    // url: '/shop/sites/sending',
    url: '/information',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getCheckSlingTool = (
  params: Types.GetCheckSlingToolRequest
): AxiosPromise<Types.GetCheckSlingToolResponse> => {
  const request: AxiosRequestConfig = {
    url: '/shop/check_sling_tool',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getShopSchedulesSelect = (
  params: Types.GetShopSchedulesSelectRequest
): AxiosPromise<Types.GetShopSchedulesSelectResponse> => {
  const request: AxiosRequestConfig = {
    url: '/cooperator/schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getCooperatorUser = (
  params: Types.GetCooperatorRequest
): AxiosPromise<Types.GetCooperatorResponse> => {
  const request: AxiosRequestConfig = {
    url: '/cooperator/user',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getUnpropertyListShop = (): AxiosPromise<Types.GetUnpropertyListShopResponse> => {
  const request: AxiosRequestConfig = {
    url: '/unproperty_list_shop',
    method: 'GET',
  };
  return instanceApi(request);
};

export const getShopWorkersChargeSiteList = (
  params: Types.getShopWorkersChargeSiteListParams
): AxiosPromise<Types.getShopWorkersChargeSiteListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/cooperators/workers_charge_site_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getWorkersChargeSiteList = (
  params: Types.getWorkersChargeSiteListParams
): AxiosPromise<Types.getWorkersChargeSiteListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/workers_charge_site_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getShopSchedulesWorkersChargeSiteList = (
  params: Types.getShopSchedulesWorkersChargeSiteListParams
): AxiosPromise<Types.getShopSchedulesWorkersChargeSiteListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/cooperators/schedules/workers_charge_site_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getBranchs = (params: Types.BranchRequest): AxiosPromise<Types.BranchResponse> => {
  const request: AxiosRequestConfig = {
    url: '/branchs',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// 2023/10/24 Leading Win 作業員シフト表廃止対応 start
export const findPropertyInfo = (
  params: Types.PropertyInfoRequest
): AxiosPromise<Types.PropertyInfoResponse> => {
  const request: AxiosRequestConfig = {
    url: '/sites/property_info',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2023/10/24 Leading Win 作業員シフト表廃止対応 end

// 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
export const getSiteGroupsWorkers = (
  params: Types.GetSiteGroupsWorkersRequest
): AxiosPromise<Types.GetSiteGroupsWorkersRsponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/groups/workers',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
